var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcFacebook = function SvgIcFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "48px",
    viewBox: "0 0 47 48",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "7639F7AF-F229-4B1E-97E9-6F0E3BD1E403")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logowanie",
    transform: "translate(-1589.000000, -1410.000000)",
    fill: "#D5D4D3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stopka",
    transform: "translate(0.000000, 1080.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(82.000000, 330.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_social",
    transform: "translate(1507.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.967041,24 C46.967041,10.7259858 36.4796025,0 23.4878221,0 C10.4960417,0 0.000498522373,10.7259858 0.000498522373,24 C-0.0690851296,34.8254628 7.15214206,44.349103 17.6095075,47.223458 L17.6095075,31.0050556 L11.7417289,31.0050556 L11.7417289,24 L17.6095075,24 L17.6095075,19.0010111 C17.6095075,13.5005056 21.5240614,9.00303337 26.41928,9.00303337 L32.2870585,9.00303337 L32.2870585,16 L26.41928,16 C25.3332547,16 24.4579507,17.3346815 24.4579507,19.0010111 L24.4579507,24 L32.2870585,24 L32.2870585,31.0050556 L24.4579507,31.0050556 L24.4579507,48 C36.9634511,47.4499494 46.9646096,36.942366 46.9646096,24 L46.967041,24 Z",
    id: "ic_facebook"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_facebook.95d3141d.svg";
export { ForwardRef as ReactComponent };